import React from 'react';
import { Link } from 'react-router-dom';
import LineDotLong from '../../images/line-dot-long.png'

class ExpiredSubscription extends React.Component {
    render() {
        return <div className="container" style={{ width: "100%", minHeight: "38.8vh" }}>
            <div class="col-sm-12 row" style={{ margin: "50px auto" }}>
                <div class="col-xs-12">
                    <div class="col-sm-12 margin">
                        <h3>
                            Expired Subscription
                        </h3>
                    </div>
                    <img src={LineDotLong} />
                </div>
                <div class="col-sm-12 margin">
                    <p>
                        The access to your product/services has ended. Please visit <Link to="/">Service Catalog</Link> to subscribe again. Otherwise please contact <a mailhref="mailto:igeoportal@iwk.com.my">igeoportal@iwk.com.my</a> for more enquiries.
                    </p>
                </div>
            </div>
        </div>;
    }
}
export default ExpiredSubscription;


// WEBPACK FOOTER //
// ./src/components/Error/ExpiredSubscription.js